import { config } from "../../config";
import { search } from "../../contract/generated/bff/src/apis/SearchApi";
import type { ISearchDataResponse } from "../../contract/generated/bff/src/models";

interface FetchSearchParams {
  q: string;
  page?: number;
  filter?: string;
}

export const fetchSearchResults = async (
  params: FetchSearchParams
): Promise<ISearchDataResponse> => {
  return search(config.apiBasePath, {
    q: params.q,
    isNative: false,
    page: params.page ?? 1,
    pageSize: 10,
    filter: params.filter,
    source: "search",
  });
};
